import styled from '@emotion/native';
import { PartialTaskWithId } from '@quromedical/models';
import { Col } from 'components/base';
import { ActionList, Card, Sidebar, useResponsiveSectionMargin } from 'design-system';
import { useIsSmallerThan } from 'hooks/useResponsive';
import React, { useMemo, useState } from 'react';
import { ScrollView } from 'react-native';
import { strings } from 'strings';

import { Content } from './Content';
import { BaseTaskList } from './internal';
import { Item } from './Item';
import { List } from './List';

const ContentWrapper = styled(Col)(() => {
  const margin = useResponsiveSectionMargin();

  return {
    marginLeft: margin,
  };
});

export const TaskInbox: BaseTaskList = props => {
  const { addNote, tasks, error, isLoading, invalidate, setStatus, setOwner } = props;
  const isSmall = useIsSmallerThan('xl');

  const [selected, setSelected] = useState<PartialTaskWithId>();

  const active = selected || tasks[0];

  const content = useMemo(
    () => (
      <ScrollView>
        <List loading={isLoading} onFilterChange={setStatus} onFilterSecondaryChange={setOwner}>
          {error ? (
            <ActionList.Item
              id="error"
              title={strings.GenericErrorMessage}
              subTitle={strings.ErrorCardTitle}
              onPress={invalidate}
            />
          ) : null}
          {tasks.map(task => {
            const isSelected = task.id === active?.id;
            const onSelect = () => setSelected(task);
            const showsSelection = isSelected && !isSmall;
            const selectionColor = showsSelection ? 'primary-10' : undefined;

            const taskOverdueColor = task.status === 'failed' ? 'status-warning' : undefined;

            const backgroundColor = taskOverdueColor ? taskOverdueColor : selectionColor;

            return (
              <Item
                key={task.id}
                task={task}
                onNoteAdd={addNote}
                onSelect={isSelected ? undefined : onSelect}
                smallItems={!isSmall}
                isDialog={isSmall}
                backgroundColor={backgroundColor}
              />
            );
          })}
        </List>
      </ScrollView>
    ),
    [active, tasks, error, invalidate, setStatus, isSmall, isLoading, addNote, setOwner]
  );

  if (isSmall) {
    return content;
  }

  return (
    <Sidebar.Container>
      <Sidebar.Aside flex={2} backgroundColor="transparent">
        {content}
      </Sidebar.Aside>
      <Sidebar.Main flex={5}>
        <ContentWrapper>
          {active ? (
            <Card>
              <Content task={active} onNoteAdd={addNote} />
            </Card>
          ) : null}
        </ContentWrapper>
      </Sidebar.Main>
    </Sidebar.Container>
  );
};
